import axios from 'axios'
import { domains } from 'config/env'
import Auth0Manager from 'auth/utils/auth0Manager'

// Factory function to create authenticated axios instances
export const createApiClient = baseURL => {
  const _api = axios.create({
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })

  _api.interceptors.request.use(async request => {
    const token = await Auth0Manager.getAccessToken()
    request.headers.Authorization = `Bearer ${token}`
    return request
  })

  return {
    delete: _api.delete,
    get: _api.get,
    patch: _api.patch,
    post: _api.post,
    put: _api.put,
    defaults: _api.defaults,
  }
}

// Default export - creates v3 API client for backward compatibility
const secondStepApi = createApiClient(`${domains.SECONDSTEP_API}/`)
export default secondStepApi
